import React from 'react'
import { Link } from 'react-router-dom'
import { buttonLinkClasses } from './styles'

export const ButtonLink = ({ to, className, children }: { to: string, className?: string, children: React.ReactNode }) => {
    return (
        <Link to={to} target="_blank" className={className + ' ' + buttonLinkClasses}>
            {children}
        </Link>
    )
}